/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import Request from 'generic/request/Request'

export const SKILLS_URL = '/api/skill/list/?meta=false&objects_count=false'

export function getSkills () {
  return Request.getRequest(SKILLS_URL)
    .then((results) => {
      return results.data.objects.objects
    })
}



// WEBPACK FOOTER //
// ./src/actions/Skill.js